export default "__VITE_ASSET__Dj_66u5j__"